export default "__VITE_ASSET__Dt0t6nbN__"